import React from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

/**
 * StatsCard - Card de estadísticas para el dashboard
 *
 * Características:
 * - Label descriptivo
 * - Valor numérico grande
 * - Indicador de cambio (positivo/negativo)
 * - Borde sutil y fondo según design system
 */
export interface StatsCardProps {
  label: string;
  value: string | number;
  change?: number;
  changeLabel?: string;
  sx?: SxProps<Theme>;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  label,
  value,
  change,
  changeLabel,
  sx = {},
}) => {
  const isPositive = change !== undefined && change >= 0;
  const changeColor = isPositive ? '#1b5e20' : '#991b1b';
  const changeBg = isPositive ? '#e8f5e9' : '#fee2e2';

  return (
    <Box
      sx={{
        backgroundColor: '#eff4ff',
        border: '1px solid #c3c5d9',
        borderRadius: '12px',
        p: 3,
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontSize: '12px',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 500,
          color: '#737688',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          mb: 1,
        }}
      >
        {label}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}>
        <Typography
          sx={{
            fontSize: '24px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            color: '#0b1c30',
            lineHeight: '32px',
            letterSpacing: '-0.01em',
          }}
        >
          {value}
        </Typography>
        {change !== undefined && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              px: 1,
              py: 0.25,
              borderRadius: '9999px',
              backgroundColor: changeBg,
              color: changeColor,
              fontSize: '12px',
              fontWeight: 700,
              mb: 0.5,
            }}
          >
            <TrendingUpIcon
              sx={{ fontSize: 14, transform: isPositive ? 'none' : 'rotate(180deg)' }}
            />
            {isPositive ? '+' : ''}
            {change}%
          </Box>
        )}
      </Box>
      {changeLabel && (
        <Typography
          sx={{
            fontSize: '12px',
            fontFamily: 'Inter, sans-serif',
            color: '#737688',
            mt: 1,
          }}
        >
          {changeLabel}
        </Typography>
      )}
    </Box>
  );
};
